import React, { useState, useEffect, memo } from 'react';
import { DaySlider } from './DaySlider';
import { useDayNavigation } from './hooks/useDayNavigation';
import { useSwipeGesture } from './hooks/useSwipeGesture';
import { JournalDateSelectorProps } from './types';
import CustomCalendar from '../../ui/CustomCalendar';

const DAYS_PER_PAGE = 5;

// Create a memoized function to convert entries to events
const createEventsFromEntries = (entries = []) => {
    return entries.map(entry => ({
        date: new Date(entry.date),
        title: 'Journal Entry',
        color: '#3B82F6'
    }));
};

const JournalDateSelector: React.FC<JournalDateSelectorProps> = memo(({
    entries = [],
    selectedDate,
    onDateSelect,
    className = ''
}) => {
    const today = new Date();

    const [entriesReady, setEntriesReady] = useState(false);

    const [events, setEvents] = useState(() => createEventsFromEntries(entries));

    useEffect(() => {
        if (entries.length > 0) {
            setEvents(createEventsFromEntries(entries));
            setEntriesReady(true);
        }
    }, [entries]);

    const {
        days,
        isScrolling,
        loadPreviousDays,
        loadNextDays,
        setCustomStartDate
    } = useDayNavigation({
        initialDate: selectedDate || today,
        daysPerPage: DAYS_PER_PAGE,
        selectedDate
    });

    const {
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd
    } = useSwipeGesture(
        50,
        loadNextDays,
        loadPreviousDays,
        isScrolling !== false
    );

    // Custom handler for calendar date selection
    const handleCalendarDateSelect = (date: Date) => {
        onDateSelect(date);
        setCustomStartDate(date);
    };

    // Handler for slider date selection
    const handleSliderDateSelect = (date: Date) => {
        if (isScrolling !== false) return;
        onDateSelect(date);
    };

    // Use key prop to force remount when entries change significantly
    const calendarKey = `calendar-${entries.length}-${entriesReady ? 'ready' : 'loading'}`;


    return (
        <div className={`space-y-3 ${className}`}>
            <CustomCalendar
                key={calendarKey}
                selectedDate={selectedDate}
                onChange={handleCalendarDateSelect}
                maxDate={today}
                events={events}
            />

            {/* <DaySlider
                days={days}
                selectedDate={selectedDate}
                entries={entries}
                onDateSelect={handleSliderDateSelect}
                isScrolling={isScrolling}
                loadPreviousDays={loadPreviousDays}
                loadNextDays={loadNextDays}
                handleTouchStart={handleTouchStart}
                handleTouchMove={handleTouchMove}
                handleTouchEnd={handleTouchEnd}
            /> */}
        </div>
    );
});

JournalDateSelector.displayName = 'JournalDateSelector';

export default JournalDateSelector;